import { QuizQuestion } from '../../api/quiz-services';

export const assessmentMetadata = {
    title: "Signs, Signals, & Pavement Markings Quiz",
    duration: 15
};

export const module4Questions: QuizQuestion[] = [
    {
        id: "M4-001",
        moduleId: "module-4",
        category: "Markings",
        text: "Yellow pavement markings always separate traffic flowing in ____.",
        options: ["The same direction", "Opposite directions", "Commercial vs Private", "Express vs Local"],
        correctAnswer: 1,
        scenario: "You are driving on a two-way street and notice the center line painted yellow. What does this indicate?",
        explanation: "Yellow lines separate opposite-flowing traffic, serving as a constant visual boundary warning you that high-speed oncoming vehicles are directly on the other side."
    },
    {
        id: "M4-002",
        moduleId: "module-4",
        category: "Markings",
        text: "A broken white line between lanes means you may ____.",
        options: ["Change lanes if safe", "Never cross", "Only turn right", "Stop immediately"],
        correctAnswer: 0,
        scenario: "You are driving on a multi-lane highway and want to change lanes across a broken white pavement marking.",
        explanation: "A broken white line indicates that lanes are flowing in the same direction and you are permitted to transition laterally, provided you signal, check mirrors, and verify your blind spots."
    },
    {
        id: "M4-003",
        moduleId: "module-4",
        category: "Markings",
        text: "Solid white lines 'lock' lanes near intersections to prevent ____ collisions.",
        options: ["Rear-end", "Side-swipe", "Head-on", "Pedestrian"],
        correctAnswer: 1,
        scenario: "As you approach a busy intersection, the broken white lane markings transition into thick, solid white lines. Why are these solid lines used?",
        explanation: "Solid white lines physically 'lock' lanes near intersections to discourage high-risk, last-second lane changes, preventing lateral side-swipe collisions in heavy traffic conflict zones."
    },
    {
        id: "M4-004",
        moduleId: "module-4",
        category: "Markings",
        text: "The 'Shark's Teeth' markings across a lane indicate you must ____.",
        options: ["Stop", "Yield", "Speed up", "Ignore"],
        correctAnswer: 1,
        scenario: "You approach a roundabout or yield intersection and see a row of solid white triangles painted across your lane (known as 'Shark's Teeth'). What must you do?",
        explanation: "The 'Shark's Teeth' triangles are the federal pavement marking for a yield line. You must slow down and yield the right-of-way to oncoming vehicles, pedestrians, or cross-traffic before proceeding."
    },
    {
        id: "M4-005",
        moduleId: "module-4",
        category: "Markings",
        text: "A thick white line across a lane at an intersection is a ____.",
        options: ["Yield line", "Stop line", "Pedestrian boundary", "Speed strip"],
        correctAnswer: 1,
        scenario: "You approach an intersection and see a thick, solid white line painted across your lane. Where must your vehicle stop?",
        explanation: "This is a stop line. You must bring your vehicle to a complete stop entirely behind this line to prevent blocking the crosswalk or creeping into cross-traffic lanes."
    },
    {
        id: "M4-006",
        moduleId: "module-4",
        category: "Signs",
        text: "Which shape is used exclusively for the STOP command?",
        options: ["Octagon", "Triangle", "Pentagon", "Diamond"],
        correctAnswer: 0,
        scenario: "A heavy snowstorm has completely covered the face of a stop sign at an intersection. How can you legally identify the command?",
        explanation: "The STOP command is the only sign designed with an eight-sided, octagonal shape. This unique geometry allows drivers from all directions to identify the stop command even if the face is completely obscured."
    },
    {
        id: "M4-007",
        moduleId: "module-4",
        category: "Signs",
        text: "A pennant-shaped sign is used to mark a ____.",
        options: ["School Zone", "No Passing Zone", "Sharp Turn", "Hospital Ahead"],
        correctAnswer: 1,
        scenario: "You are driving on a two-lane country highway and see a yellow, triangular pennant-shaped sign. What does it warn you of?",
        explanation: "A pennant sign marks a No Passing Zone. It is uniquely placed on the left side of the road so it remains visible to drivers who are preparing to pull out and pass."
    },
    {
        id: "M4-008",
        moduleId: "module-4",
        category: "Signs",
        text: "In what location is a No Passing pennant unique among traffic signs?",
        options: ["Left side of the road", "Above the lane", "On the ground", "Right side only"],
        correctAnswer: 0,
        scenario: "A passenger asks why the 'No Passing Zone' pennant sign is placed on the left side of the road rather than the standard right side.",
        explanation: "The pennant is placed on the left side of the road specifically to ensure it is directly in the line of sight of a driver who has pulled out into the left passing lane, giving them an immediate signal to abort the pass."
    },
    {
        id: "M4-009",
        moduleId: "module-4",
        category: "Signs",
        text: "A pentagon-shaped sign indicates a ____.",
        options: ["Yield", "Railroad", "School Zone", "Hospital"],
        correctAnswer: 2,
        scenario: "You are driving through a suburban area and pass a five-sided, pentagon-shaped warning sign. What should you prepare for?",
        explanation: "A five-sided (pentagon) sign is used exclusively to warn you of a school zone or pedestrian school crossing ahead. Prepare to reduce speed to 20 mph during school hours."
    },
    {
        id: "M4-010",
        moduleId: "module-4",
        category: "Signs",
        text: "Regulatory signs (the law) typically use which colors?",
        options: ["Yellow and Black", "Red, White, and Black", "Green and White", "Blue and White"],
        correctAnswer: 1,
        scenario: "A passenger asks how to quickly identify regulatory signs (which state the law) from warning signs.",
        explanation: "Regulatory signs (like Stop, Yield, Speed Limit) use a strict, high-visibility color scheme of red, white, and black to represent the absolute legal constraints of the roadway."
    },
    {
        id: "M4-011",
        moduleId: "module-4",
        category: "Signs",
        text: "What color is used for high-visibility school and pedestrian crossing signs?",
        options: ["Yellow", "Orange", "Fluorescent Yellow-Green", "White"],
        correctAnswer: 2,
        scenario: "You see a school crossing sign and notice it is painted in a highly vibrant, fluorescent color. What is this color and its purpose?",
        explanation: "Fluorescent yellow-green is designated for school, pedestrian, and bicycle crossings to ensure maximum visibility in low light, fog, or rainy conditions."
    },
    {
        id: "M4-012",
        moduleId: "module-4",
        category: "Signals",
        text: "In Ohio, Right-on-Red is permitted after a ____ stop unless prohibited by a sign.",
        options: ["Full and complete", "Rolling", "Safe", "Momentary"],
        correctAnswer: 0,
        scenario: "You are preparing to execute a legal right turn on a red signal at a busy municipal intersection. What is your first legal obligation?",
        explanation: "Under Ohio law, you may turn right on red only after coming to a full and complete stop behind the stop line, checking for any 'No Turn on Red' signs, and yielding to all pedestrians and cross-traffic."
    },
    {
        id: "M4-013",
        moduleId: "module-4",
        category: "Signals",
        text: "A flashing yellow arrow means you may turn but MUST ____.",
        options: ["Speed up", "Stop first", "Yield to oncoming traffic and pedestrians", "Expect a protected turn"],
        correctAnswer: 2,
        scenario: "You are in a left-turn lane and the signal displays a flashing yellow arrow. What is your legal obligation?",
        explanation: "A flashing yellow arrow permits turns but warns you that your turn is unprotected; you must yield to oncoming traffic and pedestrians in the crosswalk before proceeding."
    },
    {
        id: "M4-014",
        moduleId: "module-4",
        category: "Signals",
        text: "If a traffic signal is dark due to a power outage, treat the intersection as a ____.",
        options: ["Free-for-all", "Yield sign", "4-way stop", "One-way street"],
        correctAnswer: 2,
        scenario: "A storm has knocked out power, causing a busy four-way intersection's traffic signals to go completely dark. How should you treat the intersection?",
        explanation: "Under Ohio law, an unpowered or dark traffic signal must be treated as a 4-way stop. Drivers must stop completely and yield right-of-way in order of arrival, or yield to the vehicle on the right."
    },
    {
        id: "M4-015",
        moduleId: "module-4",
        category: "Signals",
        text: "A steady green light is not an 'all clear'; you should perform a ____ before entering.",
        options: ["Clearing scan (L-R-L)", "Quick brake test", "U-turn", "Double honk"],
        correctAnswer: 0,
        scenario: "You are stopped at an intersection and the light turns steady green. Why shouldn't you accelerate immediately?",
        explanation: "A green light is not an 'all clear'; you must perform a left-right-left clearing scan to check for pedestrians or red-light runners who may still be in the intersection conflict zone."
    },
    {
        id: "M4-016",
        moduleId: "module-4",
        category: "Laws",
        text: "Failing to stop behind a stop line is an automatic failure on the road test.",
        options: ["True", "False"],
        correctAnswer: 0,
        scenario: "During your Ohio driving test, you approach a stop sign and let your front bumper cross over the thick white stop line before coming to a stop. What is the consequence?",
        explanation: "Ohio law requires your vehicle to stop completely behind the stop line. Allowing any part of your vehicle to cross over it is an automatic road test failure due to the risk of pedestrian collisions."
    },
    {
        id: "M4-017",
        moduleId: "module-4",
        category: "Markings",
        text: "The triangular space between a through-lane and an exit ramp is called the ____.",
        options: ["Safety Zone", "Gore Area", "Escape Lane", "Shoulder Tip"],
        correctAnswer: 1,
        scenario: "You are exiting a high-speed highway and notice the triangular-shaped paved space separating the through-lane from the ramp. Can you drive through it?",
        explanation: "This triangular space is the 'Gore Area', which is strictly off-limits to driving. Crossing or stopping in the gore area is a high-priority violation that leads to severe high-speed rear-end and sideswipe collisions."
    },
    {
        id: "M4-018",
        moduleId: "module-4",
        category: "Signals",
        text: "A steady yellow light means ____.",
        options: ["Speed up to clear", "The light is about to turn red; clear the intersection if safe", "Stop in the middle", "Go if no cars are there"],
        correctAnswer: 1,
        scenario: "You are approaching an intersection when the traffic signal changes from green to steady yellow. What does this mean?",
        explanation: "A steady yellow light warns that red is imminent. You must stop safely if possible, or clear the intersection if you are too close to stop safely."
    },
    {
        id: "M4-019",
        moduleId: "module-4",
        category: "Signs",
        text: "The Crossbuck sign indicates a ____.",
        options: ["Hospital", "Deer Crossing", "Railroad Crossing", "State Park"],
        correctAnswer: 2,
        scenario: "You are driving on a rural road and approach a railroad crossing marked with an X-shaped regulatory sign. What is this sign?",
        explanation: "The Crossbuck is the regulatory sign indicating a railroad crossing. Treat it as a yield sign; look and listen for approaching trains before crossing the tracks."
    },
    {
        id: "M4-020",
        moduleId: "module-4",
        category: "Markings",
        text: "A double solid yellow line means passing is ____.",
        options: ["Allowed", "Restricted to one side", "Prohibited for both directions", "Only for carpools"],
        correctAnswer: 2,
        scenario: "You are trailing a slow-moving tractor on a two-lane road with a double solid yellow line down the center. Are you allowed to pass?",
        explanation: "A double solid yellow line indicates that passing is completely closed and prohibited for traffic moving in both directions due to restricted line of sight or intersection hazards."
    },
    {
        id: "M4-021",
        moduleId: "module-4",
        category: "Space",
        text: "Under ideal driving conditions, what is the minimum safe following distance behind the vehicle ahead?",
        options: ["1 second", "2 seconds", "3 to 4 seconds", "10 seconds"],
        correctAnswer: 2,
        scenario: "You are driving under ideal conditions on a high-speed roadway. What is the minimum safe following distance?",
        explanation: "A 3-to-4-second following distance under ideal conditions provides a safe buffer to react and stop if the vehicle ahead brakes suddenly, maintaining safety flow."
    },
    {
        id: "M4-022",
        moduleId: "module-4",
        category: "Intersections",
        text: "At a four-way intersection, if two vehicles arrive at the exact same time, who has the right-of-way?",
        options: ["The vehicle on the left", "The vehicle on the right", "The faster vehicle", "The vehicle that sounds its horn first"],
        correctAnswer: 1,
        scenario: "You and another vehicle arrive at a 4-way stop at the exact same time. Who has the right-of-way?",
        explanation: "When two vehicles arrive simultaneously at a 4-way stop, standard traffic rules mandate yielding to the vehicle on your right, maintaining cooperative flow."
    },
    {
        id: "M4-023",
        moduleId: "module-4",
        category: "Space",
        text: "What is a 'closed zone' in the Space Management System?",
        options: [
            "A highway lane that is open and clear of obstructions",
            "A space cushion that is blocked by an obstacle or another vehicle, preventing travel",
            "A toll-road booth",
            "A construction zone with flaggers"
        ],
        correctAnswer: 1,
        scenario: "You are scanning your path and notice a stalled truck blocking your travel lane ahead. What type of zone is this?",
        explanation: "A 'closed zone' is any space cushion blocked by obstacles, slow vehicles, or weather conditions, requiring immediate speed or lane adjustments."
    },
    {
        id: "M4-024",
        moduleId: "module-4",
        category: "Safety",
        text: "When being tailgated by another vehicle, what should a defensive driver do?",
        options: [
            "Slam on the brakes to teach them a lesson",
            "Accelerate to high speeds to pull away",
            "Speed up and tap the brakes repeatedly",
            "Gradually increase following distance in front to give both vehicles more stopping room"
        ],
        correctAnswer: 3,
        scenario: "You notice a distracted driver tailgating extremely close to your rear bumper on the highway. What should you do?",
        explanation: "If tailgated, gradually increase your own following distance in front to expand your stopping margin, reducing the need for sudden, panic braking."
    },
    {
        id: "M4-025",
        moduleId: "module-4",
        category: "Awareness",
        text: "What is the 'orderly visual search pattern' recommended for driving safety?",
        options: [
            "Staring continuously at the vehicle ahead",
            "Scanning path of travel, instrument panel, side mirrors, and rear-view mirrors repeatedly",
            "Watching pedestrians on the sidewalk only",
            "Glancing at your phone navigation screen every 10 seconds"
        ],
        correctAnswer: 1,
        scenario: "You are practicing defensive scanning and want to execute a systematic orderly visual search pattern. What does this look like?",
        explanation: "An orderly search involves scanning your path, dashboard gauges, and mirrors every few seconds to build a complete 360-degree awareness shield."
    }
];
